import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { WorkspaceInvite, WorkspaceInviteParams } from "@/types/workspace-invite";
import { jsonAuthHeaders } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";

interface WorkspaceInviteResponse {
  invited: WorkspaceInvite[];
  not_invited: WorkspaceInvite[];
}

export const useCreateWorkspaceInvite = () => {
  const userToken = useUserToken();
  return useMutation(
    (body: WorkspaceInviteParams): Promise<WorkspaceInviteResponse> =>
      fetch(ENDPOINTS.workspace_invites, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
  );
};
